import type { UpdateShopMemberRoleDto } from "../generated/schema";
import useInvalidateTeamMembers from "./use-invalidate-team-members";
import { useApiMutation } from "./use-api-mutation";

type UseUpdateTeamMemberRoleParams = {
	onSuccess?: () => void;
	onError?: () => void;
};

export default function useUpdateTeamMemberRole(
	shopId: string,
	userId: string,
	options?: UseUpdateTeamMemberRoleParams,
) {
	const invalidateShopMembers = useInvalidateTeamMembers(shopId);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/members/{userId}/role",
		{
			invalidate: invalidateShopMembers,
			onSuccess: options?.onSuccess,
			onError: options?.onError,
			mapVariables: (requestBody: UpdateShopMemberRoleDto) => ({
				params: { path: { userId, shopId } },
				body: {
					roleId:
						requestBody.roleId.toUpperCase() as UpdateShopMemberRoleDto["roleId"],
					storeId: requestBody.storeId,
					warehouseId: requestBody.warehouseId,
					trackingWarehouseId: requestBody.trackingWarehouseId,
				},
			}),
		},
	);
}
